import React, { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Box, BoxExtendedProps, ShimmerBox, Text } from '@common-fe/common-fe';

import { OcrAccountOrderOption } from '@/modules/UseMyMoney/UseMyMoney.types';

import PaymentOrderBrick from './PaymentOrderBrick';

interface Props extends BoxExtendedProps {
  accountOrders?: OcrAccountOrderOption[];
  isLoading?: boolean;
  isMobile?: boolean;
}

const PaymentOrder: React.FC<Props> = ({ accountOrders, isLoading, isMobile, ...props }) => {
  const { t } = useTranslation();

  const hasAccountOrders = useMemo(() => accountOrders?.length && accountOrders?.length > 0, [accountOrders?.length]);

  if (isLoading) {
    return (
      <Box margin={props?.margin}>
        <ShimmerBox data-testId="payment-order_loader" height='108px' />
      </Box>
    );
  }

  return (
    <Box
      data-testId="payment-order_wrapper" 
      pad="spacing16"
      background="module"
      round="container1Round"
      {...props}
    >
      <Text data-testId="payment-order_title">
        {hasAccountOrders
          ? t('Based on the service date and description, this claim will pay in the following order:')
          : t('Based on the service date and description, this claim will apply toward your deductible.')}
      </Text>

      <Box
        data-testId="payment-order_bricks-wrapper"
        pad={{ right: 'spacing24' }}
        style={{ position: 'relative' }}
        direction="row"
        wrap
      >
        {accountOrders?.map((account, index) => (
          <Box
            data-testId="payment-order_brick-wrapper"
            key={account?.accountId}
            margin={{ top: isMobile && index !== 0 ? undefined : 'spacing8' }}
            width={isMobile ? '100%' : '50%'}
          >
            <PaymentOrderBrick
              zIndex={accountOrders?.length - index}
              order={index + 1}
              account={account}
              isMobile={isMobile}
            />
          </Box>
        ))}
      </Box>
    </Box>
  );
};

export default PaymentOrder;
